import React from 'react'
import styled, { css } from 'styled-components'

const width = '20'
const height = '22'
const viewBox = '0 0 20 22'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <g fill="#FFF" key="key-0">
      <path d="M2.13 21.933h2.758l1.374-3.058a9.62 9.62 0 0 1-2.241-1.223L2.13 21.933zm10.954-3.058l1.374 3.058h2.758l-1.891-4.28a9.62 9.62 0 0 1-2.24 1.222zM5.108 15.19c.653.559 1.406 1 2.228 1.291l2.337-5.202 2.336 5.202a7.064 7.064 0 0 0 2.229-1.291L9.673 4.855 5.108 15.191z" />
      <path d="M9.673 16.885a6.97 6.97 0 0 1-2.337-.403l-1.074 2.393a9.512 9.512 0 0 0 3.41.63c1.201 0 2.35-.223 3.412-.63l-1.075-2.393a6.97 6.97 0 0 1-2.336.403zm4.565-1.694l1.087 2.461a9.625 9.625 0 0 1-2.24 1.223l-1.076-2.393a7.063 7.063 0 0 0 2.229-1.291zm-9.13 0c.653.559 1.406 1 2.228 1.291l-1.074 2.393a9.62 9.62 0 0 1-2.241-1.223l1.087-2.46z" />
      <path d="M0 9.703a9.836 9.836 0 0 0 4.02 7.95l1.088-2.462a7.206 7.206 0 0 1-2.523-5.488c0-3.13 1.988-5.798 4.751-6.779V.192C3.128 1.253 0 5.115 0 9.703M11.457.07v2.683c3.047.803 5.303 3.615 5.303 6.95 0 2.2-.981 4.17-2.522 5.488l1.087 2.462a9.835 9.835 0 0 0 4.02-7.95c0-4.786-3.404-8.782-7.888-9.633" />
    </g>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'LogoAutoWorks'
})
